export const newsConstants = {
    GET_ALL_REQUEST: 'NEWS_GET_ALL_REQUEST',
    GET_ALL_SUCCESS: 'NEWS_GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'NEWS_GET_ALL_FAILURE',

    GET_ONE_REQUEST: 'NEWS_GET_ONE_REQUEST',
    GET_ONE_SUCCESS: 'NEWS_GET_ONE_SUCCESS',
    GET_ONE_FAILURE: 'NEWS_GET_ONE_FAILURE',
    
    CREATE_ONE_REQUEST: 'NEWS_CREATE_ONE_REQUEST',
    CREATE_ONE_SUCCESS: 'NEWS_CREATE_ONE_SUCCESS',
    CREATE_ONE_FAILURE: 'NEWS_CREATE_ONE_FAILURE',
    

    UPDATE_ONE_REQUEST: 'NEWS_UPDATE_ONE_REQUEST',
    UPDATE_ONE_SUCCESS: 'NEWS_UPDATE_ONE_SUCCESS',
    UPDATE_ONE_FAILURE: 'NEWS_UPDATE_ONE_FAILURE',
    
    DELETE_ONE_REQUEST: 'NEWS_DELETE_ONE_REQUEST',
    DELETE_ONE_SUCCESS: 'NEWS_DELETE_ONE_SUCCESS',
    DELETE_ONE_FAILURE: 'NEWS_DELETE_ONE_FAILURE',
    
    DELETE_MANY_REQUEST: 'NEWS_DELETE_MANY_REQUEST',
    DELETE_MANY_SUCCESS: 'NEWS_DELETE_MANY_SUCCESS',
    DELETE_MANY_FAILURE: 'NEWS_DELETE_MANY_FAILURE',
    

      
};
